import React, { useState } from "react";
import { Table, Input, DatePicker, Space, Select, message } from "antd";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
dayjs.extend(isBetween);

const { RangePicker } = DatePicker;
const { Option } = Select;

const PaymentReport = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filterType, setFilterType] = useState("week");
  const [customRange, setCustomRange] = useState([]);
  const [paymentStatus, setPaymentStatus] = useState("All");

  const data = [
    { id: "1", date: "2025-06-17", orderId: "ORD101", customerName: "Frozen Factory", amount: 45000, paymentMode: "Online", status: "Paid" },
    { id: "2", date: "2025-06-11", orderId: "ORD102", customerName: "Gargi Foods", amount: 30000, paymentMode: "COD", status: "Pending" },
    { id: "3", date: "2025-05-29", orderId: "ORD103", customerName: "Nexus", amount: 75000, paymentMode: "Online", status: "Paid" },
    { id: "4", date: "2025-05-05", orderId: "ORD104", customerName: "Gargi Foods", amount: 15000, paymentMode: "COD", status: "Paid" },
    { id: "5", date: "2025-06-17", orderId: "ORD105", customerName: "Frozen Factory", amount: 45000, paymentMode: "Online", status: "Paid" },
    { id: "6", date: "2025-06-11", orderId: "ORD106", customerName: "Gargi Foods", amount: 30000, paymentMode: "COD", status: "Pending" },
    { id: "7", date: "2025-05-29", orderId: "ORD107", customerName: "Nexus", amount: 75000, paymentMode: "Online", status: "Paid" },
    { id: "8", date: "2025-05-05", orderId: "ORD108", customerName: "Gargi Foods", amount: 15000, paymentMode: "COD", status: "Paid" },
  ];

  const applyDateFilter = (records) => {
    const today = dayjs();
    if (filterType === "week") {
      return records.filter((item) =>
        dayjs(item.date).isBetween(today.startOf("week"), today.endOf("week"), null, "[]")
      );
    } else if (filterType === "month") {
      return records.filter((item) =>
        dayjs(item.date).isBetween(today.startOf("month"), today.endOf("month"), null, "[]")
      );
    } else if (filterType === "custom" && customRange.length === 2) {
      const [start, end] = customRange;
      if (end.diff(start, "year", true) > 1) {
        message.error("Custom date range must not exceed 1 year.");
        return [];
      }
      return records.filter((item) =>
        dayjs(item.date).isBetween(start, end, null, "[]")
      );
    }
    return records;
  };

  const applyStatusFilter = (records) => {
    if (paymentStatus === "All") return records;
    return records.filter((item) => item.status === paymentStatus);
  };

  const filteredData = applyStatusFilter(
    applyDateFilter(data).filter(
      (item) =>
        item.customerName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.orderId.toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const totalAmount = filteredData.reduce((sum, rec) => sum + rec.amount, 0);

  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      render: (text) => dayjs(text).format("DD-MM-YYYY"),
    },
    {
      title: "Order ID",
      dataIndex: "orderId",
    },
    {
      title: "Customer",
      dataIndex: "customerName",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      render: (amt) => `₹${amt.toFixed(2)}`,
    },
    {
      title: "Mode",
      dataIndex: "paymentMode",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text) => (
        <span style={{ color: text === "Paid" ? "green" : "red" }}>{text}</span>
      ),
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <h2>Payment Report</h2>

      <Space style={{ marginBottom: 16 }} wrap>
        <Select
          value={filterType}
          onChange={setFilterType}
          style={{ width: 150 }}
        >
          <Option value="week">This Week</Option>
          <Option value="month">This Month</Option>
          <Option value="custom">Custom Range</Option>
        </Select>

        {filterType === "custom" && (
          <RangePicker
            value={customRange}
            onChange={(dates) => setCustomRange(dates)}
            disabledDate={(current) =>
              current && current > dayjs().endOf("day")
            }
          />
        )}

        <Select
          value={paymentStatus}
          onChange={setPaymentStatus}
          style={{ width: 150 }}
        >
          <Option value="All">All Status</Option>
          <Option value="Paid">Paid</Option>
          <Option value="Pending">Pending</Option>
        </Select>

        <Input.Search
          placeholder="Search customer or order ID"
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ width: 250 }}
          allowClear
        />
      </Space>

      <Table
        dataSource={filteredData}
        columns={columns}
        rowKey="id"
        pagination={{ pageSize: 5 }}
        footer={() => (
          <strong style={{ float: "right" }}>
            Total Amount: ₹{totalAmount.toFixed(2)}
          </strong>
        )}
      />
    </div>
  );
};

export default PaymentReport;
